import PropTypes from 'prop-types';
import React from 'react';

import TextArea from '../../../../components/TextArea';

import '../styles.css';

const Overview = ({ onChange, initialValue }) => (
  <div styleName="transfer-overview">
    <TextArea
      value={initialValue.value}
      onChange={onChange}
      data-cy="Premium-Hem-Transfer-Overview-TextArea"
    />
  </div>
);

Overview.propTypes = {
  onChange: PropTypes.func,
  initialValue: PropTypes.object,
};
export default Overview;
